import { Params } from 'app/types';
import { get, mergeWith } from 'lodash-es';
import { FieldErrors, FieldValues } from 'react-hook-form';

export const checkErrors = (field: keyof FieldValues, errors: FieldErrors): boolean => {
  return get(errors, field) ? true : false;
};

export const getErrorMessage = (field: keyof FieldValues, errors: FieldErrors): string | null => {
  return (get(errors, `${field}.message`) as unknown as string) || null;
};

export const mergeData = (defaultValues: Params, values: Params): Params => {
  return mergeWith({}, defaultValues, values, (a, b) => (b === null ? a : undefined));
};

export const parseSearchParams = (searchParams: URLSearchParams): Params => {
  const output: Params = {};
  searchParams.forEach((v, k) => {
    output[k] = v;
  });

  return output;
};

export const parseFormValuesToParams = (values: Params): Params => {
  const output: Params = {};
  Object.keys(values).forEach((key: string) => {
    if (values[key] === null) {
      output[key] = '';
    } else {
      output[key] = values[key];
    }
  });

  return output;
};
